import React, { useEffect, Component } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
// Mapping of company slugs to their categories
const companyToCategory: Record<string, string> = {
  databricks: 'AI and Data Infrastructure',
  'play-ai': 'AI and Data Infrastructure',
  groq: 'Compute Infrastructure',
  goodnotes: 'Devtools, Productivity & Open-source',
  vectara: 'AI and Data Infrastructure',
  'clerk-chat': 'Devtools, Productivity & Open-source',
  airmdr: 'Security',
  airtrain: 'AI and Data Infrastructure',
  anecdote: 'Devtools, Productivity & Open-source',
  antigma: 'AI and Data Infrastructure',
  bullet: 'Decentralized Networks & Financial Infrastructure',
  chakra: 'AI and Data Infrastructure',
  vmax: 'AI and Data Infrastructure',
  citcon: 'Decentralized Networks & Financial Infrastructure',
  concierge: 'Devtools, Productivity & Open-source',
  datahive: 'AI and Data Infrastructure',
  gtmengine: 'Devtools, Productivity & Open-source',
  huma: 'Decentralized Networks & Financial Infrastructure',
  hyperdx: 'Devtools, Productivity & Open-source',
  inversion: 'Decentralized Networks & Financial Infrastructure',
  irys: 'Decentralized Networks & Financial Infrastructure',
  'lightning-labs': 'Decentralized Networks & Financial Infrastructure',
  maestro: 'Devtools, Productivity & Open-source',
  solana: 'Decentralized Networks & Financial Infrastructure',
  solayer: 'Decentralized Networks & Financial Infrastructure',
  notifi: 'Devtools, Productivity & Open-source',
  okareo: 'AI and Data Infrastructure',
  'opaque-systems': 'AI and Data Infrastructure',
  openlayer: 'AI and Data Infrastructure',
  opsin: 'Security',
  aesopic: 'Security',
  'pair-systems': 'AI and Data Infrastructure',
  s2: 'AI and Data Infrastructure',
  scarf: 'Devtools, Productivity & Open-source',
  shinami: 'Decentralized Networks & Financial Infrastructure',
  skypilot: 'Compute Infrastructure',
  save: 'Decentralized Networks & Financial Infrastructure',
  syntracts: 'Devtools, Productivity & Open-source',
  termina: 'Decentralized Networks & Financial Infrastructure',
  thruline: 'Devtools, Productivity & Open-source',
  'unbound-security': 'Security',
  unify: 'AI and Data Infrastructure',
  vectroid: 'AI and Data Infrastructure',
  workduo: 'Devtools, Productivity & Open-source',
  yarn: 'Devtools, Productivity & Open-source'
};
export const PortfolioRedirect = () => {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const navigate = useNavigate();
  useEffect(() => {
    if (slug) {
      const category = companyToCategory[slug.toLowerCase()];
      if (category) {
        navigate(`/companies?category=${encodeURIComponent(category)}`, {
          replace: true
        });
      } else {
        // If company not found, redirect to companies page with Featured tab
        navigate('/companies', {
          replace: true
        });
      }
    }
  }, [slug, navigate]);
  return null;
};